var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geely-ai"},[_c('div',{staticClass:"ai-content"},[_c('img',{staticClass:"ai",attrs:{"src":require("./images/geelyAI.gif"),"alt":"加载中"},on:{"click":function($event){return _vm.toAI()}}}),_c('img',{staticClass:"ai-tip",class:{ 'show-tip': _vm.showTip },attrs:{"src":require("./images/ai-bk.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }